<template>
  <div class="slider-multiple">
    <div
      class="home"
      :class="{
        domainbasedHeight: domainBasedBrand,
        offerheight: offers.length < 1,
      }"
      :style="{ 'background-image': `url('/images/slider/bg.jpg')` }"
    >
      <div class="home-slider">
        <div class="container">
          <div class="row">
            <div class="col-12 ratio_square" id="sliderm" v-if="offers.length">
              <div class="slider-title">
                <h2
                  :style="{
                    paddingBottom: domainBasedBrand ? '1rem' : null,
                    marginBottom: domainBasedBrand ? 'unset' : '0',
                  }"
                >
                  {{ _T('Offers Available Around You') }}
                  <a href="javascript:void(0)" class="d-none">
                    {{ _T('see all') }}
                  </a>
                </h2>
                <h6>
                  {{ _T('Find the best offers from your favourites stores') }}
                </h6>
              </div>
              <div
                class="home-slider-4 default-arrow slider-space s1"
                v-if="swiperOptions.slidesPerView < offers.length"
              >
                <!--{{ swiperOptions.breakpoints[breakpointsRatio].slidesPerView }}-->
                <swiper ref="mySwiper" :options="swiperOptions">
                  <swiper-slide
                    v-for="offer in offers"
                    :key="offer.id"
                    @click.native="OfferData(offer)"
                  >
                    <OfferTile :offer="offer" />
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
              <div
                class="home-slider-4 default-arrow slider-space row s2"
                v-else
              >
                <div class="col-12 p-0" v-if="windowSize < 1199">
                  <!--{{ swiperOptions.breakpoints[breakpointsRatio].slidesPerView }}-->
                  <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide
                      v-for="offer in offers"
                      :key="offer.id"
                      @click.native="OfferData(offer)"
                    >
                      <OfferTile :offer="offer" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>
                <OfferTile
                  v-else
                  class="col-lg-3 col-md-6 col-sm-12"
                  :offer="offer"
                  v-for="offer in offers"
                  :key="offer.id"
                  @click.native="OfferData(offer)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OfferTile from '../../Collections/OfferTile'
//import StorePicker from '@/components/Collections/StorePicker'
import Windowsize from '@/mixins/Windowsize'

export default {
  name: 'OffersSlider',
  props: ['offers'],
  components: {
    OfferTile,
    //StorePicker
  },
  mixins: [Windowsize],
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand']),
  },
  data() {
    return {
      breakpointsRatio: 1199, //in future will add by windows.width
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: false,
        // initialSlide: 0,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 1000,
        // direction: 'horizontal',
        // grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1199: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          460: {
            loop: true,
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: true,
            pagination: true,
          },
          320: {
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: true,
            pagination: true,
          },
        },
      },
    }
  },
  methods: {
    OfferData(offer) {
      this.$store.commit('SET_SELECTED_BRAND', offer.brand_id)
      this.$store.commit('SET_SELECTED_OFFER', offer)
      this.$store.commit('IS_STORE_BRAND', false)
      //   if(this.brandWiseStores.length ==1) {
      //   this.$router.replace({
      //     name: this.brandStoreRoute('store_page'),
      //     params:
      //       this.brandStoreParams
      //   })
      // }
      // else {
      //# this.$bvModal.show('storepicker-id')
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl .swiper-slide {
  margin-right: unset !important;
  margin-left: 30px;
}
.swiper-button-next,
.swiper-container-rtl {
  .swiper-button-prev {
    left: 10px;
    right: auto;
  }
}
.bg-img {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
}
.home {
  height: $px600;
  &.offerheight {
    height: $px230;
  }
  .home-slider-4 {
    margin-left: -$px15;
    margin-right: -$px15;
    &.row {
      justify-content: center;
    }
    .swiper-container {
      padding: 0 $px15;
      overflow-x: hidden;
      overflow-y: hidden;
      .swiper-button-prev,
      .swiper-button-next {
        width: $px50;
        height: $px50;
        background-color: $white;
        border-radius: 100%;
        box-shadow: 0px $px4 $px10 rgba($black, 0.25);
        left: 0;
        top: 39%;
        z-index: 9;
        &.swiper-button-disabled {
          opacity: 0;
        }
        &:after {
          content: '';
          background-image: url('/images/svg/global/right-arrow-1.svg');
          color: $white;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          width: $px16;
          height: $px16;
        }
      }
      .swiper-button-prev {
        &:after {
          transform: scaleX(-1);
          top: $px17;
          left: $px17;
        }
      }
      .swiper-button-next {
        left: unset;
        right: 0;
      }
      .swiper-pagination-bullets {
        bottom: 0;
        color: $white;
        .swiper-pagination-bullet {
          color: red;
        }
      }
    }
  }
}
.domainbasedHeight {
  height: $px410;
}
.slider-title {
  margin-top: $px35;
  text-align: center;
  h2 {
    color: $white;
    font-weight: bold;
    text-transform: capitalize;
    a {
      display: none;
    }
  }
  h6 {
    color: $white;
    margin-bottom: -$px4;
  }
}
@media (max-width: 991px) {
  .home {
    .home-slider-4 {
      .swiper-container {
        .swiper-button-prev,
        .swiper-button-next {
          width: $px35;
          height: $px35;
        }
        .swiper-button-prev {
          &:after {
            top: $px10;
            left: $px11;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .home {
    height: $px470;
    &.offerheight {
      height: $px470;
    }
  }
  #sliderm {
  }
}
@media (max-width: 575px) {
  .home {
    &.offerheight {
      height: auto;
    }
    height: auto;
    background-image: none !important;
    .home-slider {
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      padding: $px15 0;
      .swiper-pagination {
        display: none;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
  }
  .slider-title {
    margin-top: 0;
    h2 {
      color: $font-color;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: $px16;
      line-height: $px19;
      a {
        display: block;
        font-weight: 600;
        font-size: $px13;
        line-height: $px16;
        letter-spacing: 0.02em;
        color: $color-primary;
        margin-left: auto;
      }
    }
    h6 {
      display: none;
    }
  }
}
</style>
